// extracted by css-extract-rspack-plugin
export default {"updateRequestTh":"RequestList__updateRequestTh--Sf3Mc"};